<template>
  <v-card class="mx-auto mt-n3">
    <!-- Carousel Section -->
    <v-img :src="`${url}${data.banners[0].web}`" class="my-3" contain />
    <!-- <v-carousel
      :show-arrows="false"
      height="auto"
      cycle
      hide-delimiters
      class="topBanner pb-10"
    >
      <v-carousel-item
        v-for="(banner, i) in data.banners"
        :key="i"
        :src="`${url}${banner.web}`"
        class="my-3"
      >
        <div dark class="overlay">
          <v-row class="fill-height" align="center" justify="center">
            <v-col>
              <v-container
                :class="{ responisiveSlider: $vuetify.breakpoint.smAndDown }"
              >
                <div
                  class="slider-title"
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-15'"
                >
                  {{ banner.content }}
                </div>
              </v-container>
            </v-col>
          </v-row>
        </div>
      </v-carousel-item>
    </v-carousel> -->
    <!-- Carousel Section -->

    <!-- Header Section -->
    <v-card-title
      class="justify-center text-uppercase page-title"
      :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
    >
      {{ data.parent.title }}
    </v-card-title>
    <v-card-subtitle
      class="text-center page-sub-title"
      :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
    >
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
        {{ data.title }}
      </h1>
    </v-card-subtitle>
    <!-- Header Section -->

    <!-- Content Section -->
    <v-container
      class="bg-surface-variant"
      :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-5'"
    >
      <v-row
        no-gutters
        v-scrollanimation
        align="center"
        justify="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="[$vuetify.breakpoint.smAndDown ? 'order-2' : 'order-1']"
        >
          <v-card
            class="mx-auto"
            flat
            v-if="validateHtml(data?.contents?.[0]?.description)"
          >
            <v-card-text v-for="(cc, i) in data.contents" :key="i">
              <div class="cms-content" v-html="cc.description"></div>
            </v-card-text>
          </v-card>
          <v-card
            class="mx-auto"
            flat
            v-if="!validateHtml(data?.contents?.[0]?.description)"
          >
            <v-card-text v-for="(cc, i) in data.contents" :key="i">
              <div class="d-flex fill-height carouselText mt-5">
                <div
                  :class="{
                    'carouselText-Two': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <h2 :class="$vuetify.breakpoint.smAndDown ? 'pr-5' : 'pr-15'">
                    {{ cc.title }}
                  </h2>
                  <p class="pr-15">{{ cc.description }}</p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="[$vuetify.breakpoint.smAndDown ? 'order-1' : 'order-2']"
        >
          <v-hover>
            <v-card
              class="rounded-xl"
              style="box-shadow: 10px 10px 0 3px #e8effe; border-radius: 32px"
              :class="`${hover ? 'imgover' : 'imgleave'}`"
              slot-scope="{ hover }"
            >
              <v-img
                class="rounded-xl"
                :src="`${url}${data.contents[0].images[0]?.web?.url}`"
                :class="$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-15'"
              ></v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <!-- Secondary Header Section -->
      <v-row
        no-gutters
        v-scrollanimation
        align="center"
        justify="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col
          cols="12"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-10'"
        >
          <v-card-title
            class="justify-center text-uppercase page-title mt-10"
            :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
          >
            {{ data.secondary.header }}
          </v-card-title>
          <v-card-subtitle
            class="text-center mt-2"
            :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
          >
            <h1>{{ data.secondary.title }}</h1>
          </v-card-subtitle>
        </v-col>
      </v-row>
      <!-- Secondary Header Section -->

      <!-- Search & Filter Section -->
      <v-card
        class="mx-auto rounded-xl mb-10 mt-10 searchBox"
        v-scrollanimation
        style="padding: 10px"
        :class="[
          { searchCard: $vuetify.breakpoint.lgAndUp },
          $vuetify.breakpoint.smAndDown ? 'searchCard-small' : '',
        ]"
      >
        <v-row>
          <v-col cols="12" md="3">
            <v-list-item>
              <v-list-item-avatar rounded="0" size="20" class="mt-7 ml-5">
                <v-img :src="require('../../assets/images/search.svg')" />
              </v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <v-text-field
                    :class="{
                      widthResponsive: $vuetify.breakpoint.smAndDown,
                    }"
                    v-model="search"
                    label="Search by name"
                    single-line
                    hide-details
                    v-on:keyup="onApplyFilter"
                  ></v-text-field>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-divider class="mt-5 mb-5" vertical></v-divider>

          <v-col cols="12" md="3">
            <v-list-item two-line>
              <v-list-item-avatar rounded="0" size="20" class="mt-7 ml-5">
                <v-img
                  :src="require('../../assets/images/fooddrinkicon.svg')"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <v-select
                    :items="categories"
                    hide-details
                    :label="`${
                      data.name == 'Shopping'
                        ? 'All Categories'
                        : 'All Cuisines'
                    }`"
                    flat
                    v-model="selectedCategory"
                    @change="onApplyFilter"
                  ></v-select>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-divider class="mt-5 mb-5" vertical></v-divider>
          <v-col cols="12" md="3">
            <v-list-item two-line>
              <v-list-item-avatar rounded="0" size="20" class="mt-7 ml-5">
                <v-img
                  :src="require('../../assets/images/allterminalIcon.svg')"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <v-select
                    :items="terminals"
                    hide-details
                    label="All Terminals"
                    flat
                    v-model="selectedTerminal"
                    @change="onApplyFilter"
                  ></v-select>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-btn rounded large color="#E8EFFE" @click="onResetFilter">
                  Reset Filters
                </v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="24" v-if="allPOIs.length !== 0 && pois.length === 0">
            <h3 class="text-center">Match not found</h3>
          </v-col>
        </v-row>
      </v-card>
      <!-- Search & Filter Section -->

      <!-- Data Section -->
      <v-container class="bg-surface-variant mt-10 diningdirectoryBlock">
        <v-row
          dense
          v-scrollanimation
          align="center"
          :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
        >
          <v-col
            class="px-4"
            v-for="(poi, i) in pois"
            :key="i"
            cols="12"
            md="4"
            sm="6"
            :class="$vuetify.breakpoint.smAndDown ? 'mb-7' : 'mb-15'"
          >
            <v-card flat class="mx-auto ma-2" height="auto" width="100%">
              <div class="headingBox-txt">
                <h2>{{ poi.name }}</h2>
                <p>{{ poi.subCategory }}</p>
              </div>
              <v-hover>
                <v-card
                  flat
                  :class="`${hover ? 'imgover' : 'imgleave'}`"
                  slot-scope="{ hover }"
                >
                  <v-img :src="poi.src" class="mt-3 mb-3 rounded-xl"></v-img>
                </v-card>
              </v-hover>
              <v-card-actions class="imageBox-txt">
                <v-card-title v-text="poi.location"></v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  dark
                  class="gradient-button pl-4 pr-4"
                  @click="onHandleMoreInfo(poi)"
                >
                  More Info
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- Data Section -->

      <!-- Dialog box Start -->
      <v-dialog
        transition="dialog-bottom-transition"
        scrollable
        max-width="930"
        style="box-shadow: none !important"
        v-model="isDialogVisible"
      >
        <template v-slot:default="isDialogVisible">
          <v-card
            flat
            class="rounded-xl popuplgScreen"
            :class="{
              popupsmallScreen: $vuetify.breakpoint.smAndDown,
            }"
          >
            <v-row>
              <v-col sm="12" md="12">
                <v-btn icon dark @click="onCloseDialog()" class="closeBtn">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col></v-row
            >

            <v-row
              class="pb-15 rounded-xl"
              :class="$vuetify.breakpoint.smAndDown ? 'pr-0' : 'pr-8'"
            >
              <v-col sm="12" md="6" style="padding: 0 !important">
                <v-sheet>
                  <v-hover>
                    <v-card
                      :class="`${hover ? 'imgover' : 'imgleave'}`"
                      slot-scope="{ hover }"
                      flat
                    >
                      <v-img
                        :src="selectedPOI.src"
                        class="popupImg fill-height"
                        :width="$vuetify.breakpoint.smAndDown ? '100%' : '100%'"
                        :class="{
                          popupImgsmallScreen: $vuetify.breakpoint.smAndDown,
                        }"
                      ></v-img>
                    </v-card>
                  </v-hover>
                </v-sheet>
              </v-col>
              <v-col
                sm="12"
                md="6"
                class="modelTextDesktop"
                :class="{
                  modalTextmobile: $vuetify.breakpoint.smAndDown,
                }"
              >
                <v-row>
                  <v-col
                    cols="12"
                    :class="{
                      modalText: $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    <h1 class="mt-3">{{ selectedPOI.name }}</h1>
                    <p class="mt-2 details-dialog-description">
                      {{ selectedPOI.description }}
                      <v-tooltip location="top" activator="parent">
                        {{ selectedPOI.description }}
                      </v-tooltip>
                    </p>
                  </v-col>
                </v-row>
                <v-row :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-2'">
                  <v-col
                    sm="12"
                    md="6"
                    :class="{
                      modalText2: $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    <P>Location</P>
                    <span class="dtlrestu">{{ selectedPOI.location }}</span>
                  </v-col>
                  <v-col
                    sm="12"
                    md="6"
                    :class="{
                      modalText2: $vuetify.breakpoint.smAndDown,
                    }"
                    v-if="selectedPOI.timing != undefined"
                  >
                    <P>Timings</P>
                    <span class="dtlrestu">{{ selectedPOI.timing }}</span>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    :class="{
                      charmSmall: $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    <v-card-actions style="padding: 0 !important">
                      <v-btn
                        :href="`tel:${selectedPOI.mobile_number}`"
                        rounded
                        dark
                        class="gradient-button text-capitalize mr-5"
                        style="padding: 10px 20px 10px 10px !important"
                        :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-1'"
                        v-if="
                          selectedPOI.mobile_number != 0 &&
                          selectedPOI.mobile_number != ''
                        "
                      >
                        <span class="mdi mdi-phone mr-2"></span>Call
                      </v-btn>
                      <v-btn
                        :href="`mailto:${selectedPOI.email}`"
                        target="_blank"
                        rounded
                        dark
                        class="gradient-button text-capitalize mr-5"
                        style="padding: 10px 20px 10px 10px !important"
                        :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-1'"
                        v-if="
                          selectedPOI.email != '' &&
                          selectedPOI.email != undefined
                        "
                      >
                        <span class="mdi mdi-email mr-2"></span>
                        Email
                      </v-btn>
                      <v-btn
                        :href="`https://godutyfree.in`"
                        target="_blank"
                        rounded
                        dark
                        class="gradient-button text-capitalize mr-5"
                        style="padding: 10px 20px 10px 10px !important"
                        :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-1'"
                        v-if="selectedPOI.website != undefined"
                      >
                        <span class="mdi mdi-link-variant mr-2"></span>
                        Website
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </v-dialog>
      <!-- Dialog box End -->
    </v-container>
    <!-- Content Section -->
  </v-card>
</template>
<script>
import api from "../../api";
import config from "../../config";
export default {
  name: "Template-5",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
      isDialogVisible: false,
      search: null,
      terminals: [],
      selectedTerminal: "",
      categories: [],
      selectedCategory: "",
      allPOIs: [],
      pois: [],
      selectedPOI: null,
      language: this.$store.getters.language,
    };
  },
  methods: {
    validateHtml(string = null) {
      const regex = new RegExp(/<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/);
      return string ? regex.test(string) : false;
    },
    async onLoadPOIs() {
      try {
        const { data } = await api.poi.post("poisroute/getpois", {
          appname: config.poi.app_name,
          token: config.poi.token,
        });
        if (data.success) {
          let category =
            this.data.name == "Shopping" ? this.data.name : "Food & Drink";
          let filteredPois = data.data.filter(
            (element) => element.category == category
          );
          let categories = [];
          let terminals = [];
          let pois = [];
          for (const poi of filteredPois) {
            if (
              poi.subcategory &&
              !categories.some((category) => category.value === poi.subcategory)
            ) {
              categories.push({
                text: this.capitalize(poi.subcategory),
                value: poi.subcategory,
              });
            }

            if (!terminals.some((terminal) => terminal.value === poi.terminal))
              terminals.push({
                text: `Terminal-${poi.terminal}`,
                value: poi.terminal,
              });

            delete poi.name;
            pois.push({
              ...poi,
              name: poi.poi_multilingual[String(this.language).toLowerCase()]
                .name,
              description:
                poi.poi_multilingual[String(this.language).toLowerCase()]
                  .description,
              subCategory: this.capitalize(poi.subcategory),
              src:
                poi.poi_url != ""
                  ? poi.poi_url
                  : require("../../assets/images/d1.jpg"),
              location: `T ${poi.terminal} ${poi.sliceid}`,
              terminal: poi.terminal,
            });

            terminals.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
            this.terminals = [{ text: "All", value: "" }, ...terminals];
            this.categories = [{ text: "All", value: "" }, ...categories];
            this.allPOIs = this.pois = [...pois];
          }
        }
      } catch (error) {}
    },
    onApplyFilter() {
      let data = this.allPOIs;
      if (!this.search && !this.selectedCategory && !this.selectedTerminal) {
        this.pois = this.allPOIs;
        return;
      }

      if (this.selectedTerminal) {
        data = data.filter((item) => item.terminal === this.selectedTerminal);
      }

      if (this.selectedCategory) {
        data = data.filter(
          (item) => item.subcategory === this.selectedCategory
        );
      }

      if (this.search) {
        data = data.filter((item) =>
          String(item.name)
            .toLowerCase()
            .includes(String(this.search).toLowerCase())
        );
      }

      this.pois = data;
    },
    onResetFilter() {
      this.search = "";
      this.selectedCategory = "";
      this.selectedTerminal = "";
      this.pois = this.allPOIs;
    },
    onHandleMoreInfo(poi) {
      this.selectedPOI = poi;
      this.isDialogVisible = true;
    },
    onCloseDialog() {
      this.isDialogVisible = false;
    },
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  async mounted() {
    await this.onLoadPOIs();
  },
};
</script>
<style scoped>
.diningdirectoryBlock .v-sheet.v-card:not(.v-sheet--outlined),
.fooddrinkImg .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.imageBox-txt.v-card__actions {
  padding: 0 !important;
}

.v-dialog.FandD-dialogBox {
  overflow: hidden;
}

.v-dialog.FandD-dialogBox h2 {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #1b63f8;
}

.v-dialog.FandD-dialogBox h1 {
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.02em;
  color: #374151;
}

.v-dialog.FandD-dialogBox h3 {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #374151;
}

.v-dialog.FandD-dialogBox p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #6b7280;
}

.dtlrestu {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #374151;
}

.carouselText .v-card__actions {
  padding: 0;
}
.modalText h2 {
  font-size: 12px;
  margin-top: 2px;
}
.modalText h1 {
  font-size: 14px;
}
.modalText h3 {
  font-size: 10px;
}

.modalText2 .v-btn {
  margin-top: 5px;
}
.modalText2 .gradient-button {
  font-size: 10px !important;
}

.modalText2 .v-btn.filterBtn {
  min-width: 72px !important;
}

.searchBox {
  max-width: 1050px;
  margin: 0 auto;
}
.searchBox .v-list-item {
  padding: 0 !important;
}

.img-desk {
  width: 100%;
  height: 27vh;
}
.img-mob {
  width: 100%;
  height: 20vh;
}

.theme--dark.v-btn.v-btn--icon {
  color: #000 !important ;
}

.overlay {
  width: 100%;
  height: 100%;
  /*background: linear-gradient(180deg, rgba(17, 24, 39, 0.2) 0.08%, rgba(17, 24, 39, 0.4) 41.89%, rgba(17, 24, 39, 0.8) 100%);*/
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.slider-title {
  font-size: 32px;
  font-weight: 700;
  width: 50%;
  line-height: 50px;
  color: #fff;
  letter-spacing: 1px;
}

.responisiveSlider .slider-title {
  font-size: 12px;
  width: 80%;
  line-height: 20px;
}

.modelTextDesktop h1 {
  line-height: 38px;
  margin-bottom: 10px;
  font-size: 30px;
}
.modalTextmobile h1 {
  font-size: 20px;
  line-height: 28px;
}

.popupImg {
  border-radius: 0 30px 30px 0 !important;
  margin-top: 20px;
  margin-right: 20px;
}

.popupImgsmallScreen {
  border-radius: 15px !important;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  margin-top: 10px;
}

.popuplgScreen {
  padding: 50px 0 10px 0;
}

.popupsmallScreen {
  padding: 15px;
}
.popupsmallScreen .v-card__actions {
  display: inline-flex;
}

.modelTextDesktop {
  padding: 0 50px 0 50px;
}
.modelTextDesktop p {
  margin: 0;
}
.modalTextmobile {
  padding: 0 20px;
}
.closeBtn {
  float: right;
  margin-right: 40px;
}

.searchCard-small {
  min-height: 350px;
}
</style>
